import { useParams, useLocation } from 'react-router-dom'

function useType() {
    const location = useLocation()
    const pathname = location.pathname + '/'
    if(pathname.startsWith('/fashuo/')) {
        return 'fashuo'
    }
    return 'fakao'

    const route_params = useParams()

    if (!('type' in route_params)) {
        return 'fakao'
    }

    const list = ['fakao', 'fashuo']
    if (list.indexOf(route_params.type) === -1) {
        return 'fakao'
    }

    return route_params.type
}

function useCnType() {
    const type = useType()
    const cn_key = {
        'fakao': '法考',
        'fashuo': '法硕'
    }

    return cn_key[type]
}

export {
    useType,
    useCnType
}
